import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { checkPermission, checkAnyPermission, getUserPermissions } from '../hooks/usePermission';

interface PermissionRouteProps {
  children: ReactNode;
  permission?: string;
  anyPermission?: string[];
  fallback?: string;
}

export const PermissionRoute = ({ children, permission, anyPermission, fallback = '/dashboard' }: PermissionRouteProps) => {
  const token = localStorage.getItem('auth_token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is admin (admins bypass permission checks)
  const permissions = getUserPermissions();
  if (permissions.includes('*')) {
    return <>{children}</>;
  }

  // Check specific permission
  if (permission && !checkPermission(permission)) {
    return <Navigate to={fallback} replace />;
  }

  // Check if user has any of the listed permissions
  if (anyPermission && anyPermission.length > 0 && !checkAnyPermission(...anyPermission)) {
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
};
